<template>
  <UiPageTitle title="Финансы" hide-arrow />
</template>

<script>
import UiPageTitle from '@/components/UiPageTitle.vue'

export default {
  components: { UiPageTitle },
}
</script>
